import { Injectable } from '@angular/core';
import { convertFromSapDate } from 'src/app/lego-utils';
import { IAdapter } from 'src/app/models';
import { ItemLog } from 'src/app/models/domain';
import { YPMITEMLOGSRVItemlog } from 'src/generated-clients/itemlog';

@Injectable({
  providedIn: 'root',
})
export class ItemLogAdapter implements IAdapter<ItemLog, YPMITEMLOGSRVItemlog> {
  public adaptToDomain(item: YPMITEMLOGSRVItemlog): ItemLog {
    return new ItemLog(
      item.codeGroup ?? '',
      item.activityCode ?? '',
      item.activityCodeText ?? '',
      item.activityText ?? '',
      item.createdBy ?? '',
      convertFromSapDate(item.createdOn) ?? undefined
    );
  }
}
